import { axiosController } from '@/lib/network';
import { Result } from '@/lib/type';
import { CreditCard } from '@/pages/admin/bill/models';

export type CreditCardResult = {
  default_card: string | null;
  credit_cards: CreditCard[] | null;
};
export async function getCreditCardsReq(): Promise<CreditCardResult> {
  const response = await axiosController.get('/v2/billing/credit-cards');
  return response.data.Result;
}

export async function setDefaultCardReq(cardId: string) {
  const response = await axiosController.post('/v2/billing/credit-cards/default/' + cardId);
  return response.data.Result;
}

export async function deleteCardReq(cardId: string) {
  const response = await axiosController.delete('/v2/billing/credit-cards/' + cardId);
  return response.data.Result;
}

export async function getSessionToken(): Promise<string> {
  const response = await axiosController.post('/v2/billing/session');
  return response.data.Result;
}

export enum MarketplaceStatusEnum {
  Active = 'active',
  Cancelled = 'cancelled',
  Deleted = 'deleted',
  NoSubscription = 'no subscription',
  PendingInCancellation = 'pending cancellation',
  Pending = 'pending',
}

export enum PlatformEnum {
  AWS = 'aws',
  Azure = 'azure',
  GCP = 'gcp',
}
export type PaymentMethodType = 'AWS_MARKETPLACE' | 'STRIPE';
export type PaymentMethodStatuses = {
  aws: MarketplaceStatusEnum;
  azure: MarketplaceStatusEnum;
  gcp: MarketplaceStatusEnum;
  payment_method: PaymentMethodType;
  switch_payment_method_status: { target_payment_method: PaymentMethodType; switch_time: string } | undefined;
};
export async function associateMarketplace(platform: string): Promise<Result> {
  const response = await axiosController.post(`/v2/billing/marketplace/${platform}`, null, { withCredentials: true });
  return response.data;
}

export async function getMarketplaceStatus(): Promise<PaymentMethodStatuses> {
  const response = await axiosController.get('/v2/billing/status');
  return response.data.Result;
}

export async function switchPaymentMethod(method: PaymentMethodType, defaultCardId: string = ''): Promise<Result> {
  const response = await axiosController.post(`/v2/billing/payment-method/switch`, {
    target_payment_method: method,
    default_card_id: defaultCardId,
  });
  return response.data;
}

export type CustomerInfo = {
  customer_email: string;
  address?: {
    line1: string;
    state: string;
    city: string;
    postalCode: string;
    country: string;
  };
};

export type UpdateCustomerRequest = {
  customer_email?: string;
  address?: {
    line1: string;
    state: string;
    city: string;
    postalCode: string;
    country: string;
  };
};

export async function getCustomerInfo(): Promise<CustomerInfo> {
  const response = await axiosController.get('/v2/billing/customer');
  return response.data.Result;
}

export async function updateCustomer(data: UpdateCustomerRequest) {
  const response = await axiosController.post('/v2/billing/customer/update', data);
  return response.data.Result;
}
